
import React from 'react';

interface QuizEmptyStateProps {
  questionsLength: number;
}

const QuizEmptyState: React.FC<QuizEmptyStateProps> = ({ questionsLength }) => {
  if (questionsLength === 0) {
    return <div className="text-center py-4">Deze campagne heeft geen vragen.</div>;
  }
  
  return <div className="text-center py-4">Geen vraag beschikbaar.</div>;
};

export default QuizEmptyState;
